import { Card, Col, Flex, Row, Typography } from "antd"
import React, { type ReactNode } from "react"

import { RecordRef } from "../../../../components/RecordRef.tsx"
import { empty } from "../../../../constants/placeholders"
import { getEntityName } from "../../../../utils/user/get-entity-name"
import { type Lead } from "../../../Lead/types/lead.types.ts"
import { getActions } from "../LeadsApprovalList/columns-actions.tsx"

const { Title, Text } = Typography

interface LeadsApprovalMobileCardProps {
  lead: Lead
  loading: boolean
  saving: boolean
  onActionClick: (lead: Lead, active: string) => void
}

export const LeadsApprovalMobileCard = ({
  lead,
  loading,
  saving,
  onActionClick
}: LeadsApprovalMobileCardProps) => {
  const date = empty

  const actions = getActions({ onSelectRow: onActionClick, saving })
  const customer = lead?.customer || lead?.temporary_customer
  // const salesManager = lead?.sales_manager?.[0]

  return (
    <Card
      loading={loading}
      size={"small"}
      title={
        <Flex vertical gap={4}>
          <RecordRef uid={lead?.uid} compact />
          <Title className={"!mb-0"} level={5}>
            {lead?.lead_name}
          </Title>
        </Flex>
      }
    >
      <Flex vertical gap={"middle"}>
        <Flex vertical gap={"small"}>
          <Row>
            <Col span={12}>
              <Text type={"secondary"}>Client</Text>
            </Col>
            <Col span={12} className={"text-right"}>
              <Text>{getEntityName(customer)}</Text>
            </Col>
          </Row>
          {/*<Row>*/}
          {/*  <Col span={12}>*/}
          {/*    <Text type={"secondary"}>Sales Rep</Text>*/}
          {/*  </Col>*/}
          {/*  <Col span={12} className={"text-right"}>*/}
          {/*    <Text>{getEntityName(salesManager)}</Text>*/}
          {/*  </Col>*/}
          {/*</Row>*/}
          <Row>
            <Col span={12}>
              <Text type={"secondary"}>Date</Text>
            </Col>
            <Col span={12} className={"text-right"}>
              <Text>{date}</Text>
            </Col>
          </Row>
          {/*<Row>*/}
          {/*  <Col span={12}>*/}
          {/*    <Text type={"secondary"}>Value</Text>*/}
          {/*  </Col>*/}
          {/*  <Col span={12} className={"text-right"}>*/}
          {/*    <Text>{amount}</Text>*/}
          {/*  </Col>*/}
          {/*</Row>*/}
        </Flex>
        <Flex justify={"end"}>
          {actions?.render?.("", lead, 0) as ReactNode}
        </Flex>
      </Flex>
    </Card>
  )
}
